import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { filter, take } from 'rxjs/operators';
import { FieldTrackingConfig } from 'src/app/config/eev-form-tracking.config';
import { AuthEventType } from 'src/app/enums/event/event.enum';
import { FieldInteraction } from 'src/app/models/event-data.model';
import { EventTrackingService } from 'src/app/services/event-tracking.service';

@Component({
    selector: 'app-terms-of-use-checkbox',
    templateUrl: './terms-of-use-checkbox.component.html',
    styleUrls: ['./terms-of-use-checkbox.component.scss'],
    standalone: false
})
export class TermsOfUseCheckboxComponent implements OnInit {
  @Input() parentForm: UntypedFormGroup;
  @Input() eevTrackingConfig: FieldTrackingConfig;

  @Output() checkboxChange: EventEmitter<boolean> = new EventEmitter();

  private checkboxChanged$: Subject<boolean> = new Subject();
  constructor(
    private eventTrackingService: EventTrackingService
  ) {}

  ngOnInit() {
    if (this.eevTrackingConfig) {
      this.checkboxChanged$.pipe(
        filter(x => x == true),
        take(1)
      ).subscribe(
        () => this.eventTrackingService.trackEvent<FieldInteraction>(AuthEventType.FIELD_INTERACTION, this.eevTrackingConfig.event)
      )
    }
  }

  onChecked(event) {
    this.checkboxChange.emit(event.checked);
    this.checkboxChanged$.next(event.checked);
  }

  getCheckboxError() {
    if (
      this.parentForm.get('isDisclosureChecked').touched &&
      this.parentForm.get('isDisclosureChecked').hasError('required')
    ) {
      return true;
    }
  }
}